<template>
    <v-form
        ref="form"
        v-model="valid"
        class="p-3 pt-0"
        @submit="onSubmit"
        >
        <v-text-field
          v-model="form.name"
          :error-messages="nameErrors"
          :counter="30"
          label="Name"
          required
          @input="$v.form.name.$touch()"
          @blur="$v.form.name.$touch()"
          :disabled="isAdded">
        </v-text-field>
        <v-text-field
            v-model="form.email"
            :error-messages="emailErrors"
            label="E-mail"
            required
            @input="$v.form.email.$touch()"
            @blur="$v.form.email.$touch()"
            :disabled="isAdded">
        </v-text-field>

        <v-select
            v-model="form.roles"
            :items="roles"
            :error-messages="rolesErrors"
            :rules="[v => !!v || 'Role is required']"
            label="Role"
            :disabled="isAdded">
        </v-select>

        <v-text-field
            v-model="form.password"
            type="password"
            name="password"
            label="Password"
            hint="At least 8 characters, one uppercase, one lowercase, one number, and one special character"
            counter
            @input="$v.form.password.$touch()"
            @blur="$v.form.password.$touch()"
            :error-messages="passwordErrors"
            :disabled="isAdded">
        </v-text-field>

        <v-text-field
            v-model="form.password_confirmation"
            type="password"
            name="password"
            label="Password Confirmation"
            hint="Must match password"
            counter
            @input="$v.form.password_confirmation.$touch()"
            @blur="$v.form.password_confirmation.$touch()"
            :error-messages="password_confirmationationErrors"
            :disabled="isAdded">
        </v-text-field>

        <div class="mt-3">
            <v-btn type="submit" small class="mr-4" color="primary" v-show="!is_disabled">{{ submitText }}</v-btn>
            <v-btn small @click="clear" :disabled="isAdded">clear</v-btn>
            <v-btn small class="float-right" :to="{ name: 'user list' }" v-show="!is_disabled">Close</v-btn>
        </div>

    </v-form>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, maxLength, minLength, email, helpers } from 'vuelidate/lib/validators'
import { EventBus } from '../../event-bus.js'

const strongPassword = helpers.regex('strongPassword', /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+~[\]{}|:;<>,.?/])[A-Za-z\d!@#$%^&*()_+~[\]{}|:;<>,.?/]+$/)

export default {
    mixins: [validationMixin],
    validations: {
        form: {
            name: { required, maxLength: maxLength(30) },
            email: { required, email },
            roles: { required },
            password: {
                required,
                minLength: minLength(8),
                strongPassword
            },
            password_confirmation: {
                required,
                minLength: minLength(8),
                sameAsPassword: helpers.withParams({}, function(value) {
                    return this.form.password === value
                })
            }
        }
    },

    props: {
        dataForm: {
            type: Object,
            default: () => {
                return {
                    valid: false,
                    name: '',
                    email: '',
                    roles: '',
                    password: '',
                    password_confirmation: '',
                }
            }
        },
        submitText: { type: String, default: 'Save' },
        submit: { type: Function, default: (data) => {} },
        is_disabled: { type: Boolean, default: false },
        isAdded: { type: Boolean, default: false },
    },

    data() {
        return {
            valid: false,
            roles: [
                { value: 'Super Admin', text: 'Super Admin' },
                { value: 'Admin', text: 'Admin' },
                { value: 'User', text: 'User' }
            ],

            form: {
                name: '',
                email: '',
                roles: '',
                password: '',
                password_confirmation: '',
            }

        }
    },

    created() {

        // bind with props
        this.form.name = this.dataForm.name
        this.form.email = this.dataForm.email
        this.form.roles = this.dataForm.roles.length > 0 ? this.dataForm.roles[0] : null
        this.form.password = this.dataForm.password
        this.form.password_confirmation = this.dataForm.password_confirmation
    },


    computed: {

        nameErrors () {
            const errors = []
            if (!this.$v.form.name.$dirty) return errors
            !this.$v.form.name.maxLength && errors.push('Name must be at most 30 characters long')
            !this.$v.form.name.required && errors.push('Name is required.')
            return errors
        },
        emailErrors () {
            const errors = []
            if (!this.$v.form.email.$dirty) return errors
            !this.$v.form.email.email && errors.push('Must be valid email')
            !this.$v.form.email.required && errors.push('Email is required')
            return errors
        },
        rolesErrors() {
            const errors = []
            if (!this.$v.form.roles.$dirty) return errors
            !this.$v.form.roles.required && errors.push('Role is required')
            return errors
        },
        passwordErrors() {
            const errors = []
            if (!this.$v.form.password.$dirty) return errors
            !this.$v.form.password.required && errors.push('Password is required.')
            !this.$v.form.password.minLength && errors.push('Password must be at least 8 characters long')
            !this.$v.form.password.strongPassword && errors.push('Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character (@$!%*?&)')
            return errors
        },
        password_confirmationationErrors() {
            const errors = []
            if (!this.$v.form.password_confirmation.$dirty) return errors
            !this.$v.form.password_confirmation.required && errors.push('Password confirmation is required.')
            !this.$v.form.password_confirmation.minLength && errors.push('Password confirmation must be at least 8 characters long')
            !this.$v.form.password_confirmation.sameAsPassword && errors.push('Password confirmation does not match.')
            return errors
        }
    },

    methods: {
        triggerValidation() {
            this.$v.form.$touch()

            return this.valid ? 1 : 0
        },
        userForm() {
            return this.form
        },
        onSubmit(e) {
            e.preventDefault()
            this.$v.form.$touch()

            setTimeout(function() {
                if (this.valid) {

                    // submit to UserAdd or UserEdit
                    this.submit(this.form)
                } else {
                    EventBus.$emit('show-error', 'Failed! Please try again.')
                }
            }.bind(this), 100)
        },

        clear() {
            this.$refs.form.reset()
        }
    }
}
</script>
